import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Loader from '../../../assets/components/loader';

import { useNavigate } from 'react-router-dom';

import { getCustomerByEmail, otpGeneration, verifyOtp } from "../../../store/actions";

import { getCustomer, focusInput } from '../../../utils/helpers';

const Login = () => {

  const dispatch = useDispatch();
  const loginInfo = useSelector((state) => state.login);
  const navigate = useNavigate();

  const customerId = getCustomer();

  const [user, setUser] = useState({
    email: {
      value:"",
      focused: false,
      error:""
    },
    password: {
      value: "",
      focused: false,
      error: ""
    }
  })

  useEffect(()=>{
    if(customerId !== ""){
      navigate('/mySubscriptions');
    }
  },[])

  useEffect(() => {
    if (loginInfo.emailExist && loginInfo.userName !== ""){
      dispatch(otpGeneration({ email: user.email.value, name: loginInfo.userName }))
    }
  }, [loginInfo.emailExist && loginInfo.userName !== ""])

  useEffect(() => {
    if (loginInfo.otpVerified && loginInfo.targetRedirect !== ""){
      navigate(loginInfo.targetRedirect);
    }
  }, [loginInfo.otpVerified, loginInfo.targetRedirect])

  const handleInputChange = (ev) => {
    setUser(prevUser => ({
      ...prevUser,
      [ev.target.name]: {
        ...prevUser[ev.target.name],
        value: ev.target.value,
        focused: true,
        error: validateEmail(ev.target.value)
      }
    }))
  }

  const validateEmail = (value) => {
    let errorMessagge = ""
    const validRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (value === ""){
      errorMessagge = "This field is required"
    } else if (!value.match(validRegex)){
      errorMessagge = "Email format is incorrect";
    }
    return errorMessagge
  }

  const handleSubmit = (ev) => {
    ev.preventDefault()
    let data = {
      email: user.email.value,
      showNotification: true
    }
    dispatch(getCustomerByEmail(data))
  }

  const loading = (ev) => {
    ev.preventDefault()
    let data = {
      user_otp: user.password.value,
      key: loginInfo.key,
      email: user.email.value,
      customerId: loginInfo.customerId
    }
    dispatch(verifyOtp(data))
  }

  return (
    <>
      <div className='login'>
        <form className='marquet--form' onSubmit={loginInfo.loginStep === 1 ? (ev) => { handleSubmit(ev) } : (ev) => { loading(ev) }} >
          <div className='marquet--form--group'>
            <div onClick={ev => focusInput(ev)} className={user.email.focused === true ?
              user.email.error === "" ? "input--group input--success" : "input--group input--error" : "input--group" }>
              <label>Email Address</label>
              <input
                name="email"
                type="text"
                autoComplete='off'
                maxLength={30}
                onChange={ev => handleInputChange(ev)}
                value={user.email.value} />
            </div>
            <div className="invalid--feedback">{user.email.error}</div>
          </div>
          {loginInfo.loginStep === 1?
            <div onClick={ev => focusInput(ev)} className="marquet--button--group">
              <button
                className="custom--button"
                disabled={loginInfo.loading}
                type='submit'>
                Proceed
                {loginInfo.loading && <Loader size="xs" />}
              </button>
            </div>
            :
            <>
              <div className='marquet--form--group'>
                <div className='input--group'>
                  <label>One Time Password (OTP)</label>
                  <input
                    name="password"
                    type="text"
                    autoComplete='off'
                    maxLength={30}
                    onChange={ev => handleInputChange(ev)}
                    value={user.password.value} />
                </div>
              </div>
              <div className="marquet--button--group">
                <p>Enter the OTP sent to your email</p>
                <a type='button' className="custom--links" onClick={(ev) => { dispatch(otpGeneration({ email: user.email.value, name: loginInfo.userName })) }}>
                  Request for a new OTP
                  {loginInfo.loadingOtp && <Loader size="xs" />}
                </a>
                <button
                  className="custom--button"
                  type='submit'
                  disabled={loginInfo.loading}
                  >
                  Login
                  {loginInfo.loading && <Loader size="xs" />}
                </button>
              </div>
            </>
          }
        </form>
      </div>
    </>
  )
}
export default Login;